/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const QuestionContentWrap = styled.div`
  & img {
    max-width: 100% !important;
  }
`;
